import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcMaintenance = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M13 15.5v2h7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-2h-6v2a1 1 0 1 1-2 0v-2H5v2a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1h7v-2h2Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.577 1.5a.5.5 0 0 1 .493.418l.067.4a.533.533 0 0 0 .372.413 4.995 4.995 0 0 1 1.866 1.08.533.533 0 0 0 .544.114l.381-.142a.5.5 0 0 1 .608.218l.577.998a.5.5 0 0 1-.115.636l-.313.258a.533.533 0 0 0-.173.528 5.019 5.019 0 0 1 0 2.158.533.533 0 0 0 .173.528l.313.258a.5.5 0 0 1 .115.636l-.576.998a.5.5 0 0 1-.609.218l-.38-.142a.533.533 0 0 0-.545.114 4.994 4.994 0 0 1-1.866 1.08.533.533 0 0 0-.372.414l-.067.4a.5.5 0 0 1-.493.417h-1.153a.5.5 0 0 1-.493-.418l-.067-.4a.533.533 0 0 0-.371-.413 4.994 4.994 0 0 1-1.867-1.08.533.533 0 0 0-.544-.114l-.38.142a.5.5 0 0 1-.61-.218l-.576-.998a.5.5 0 0 1 .115-.636l.313-.258a.533.533 0 0 0 .173-.528 5.018 5.018 0 0 1 0-2.158.533.533 0 0 0-.173-.528l-.313-.258A.5.5 0 0 1 6.516 5l.577-.998a.5.5 0 0 1 .608-.218l.38.142c.188.07.397.02.545-.114a4.995 4.995 0 0 1 1.867-1.08.533.533 0 0 0 .371-.414l.067-.4a.5.5 0 0 1 .493-.417h1.153Zm-.576 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcMaintenance");

export { IcMaintenance };
//# sourceMappingURL=ic-maintenance.js.map
